export const GET_CMS_MAIN_NAV_BAR = "GET_CMS_MAIN_NAV_BAR";
export const GET_CMS_MAIN_NAV_BAR_ERROR = "GET_CMS_MAIN_NAV_BAR_ERROR";